import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/state.js';
import { queryAll as e } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-all.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { renderDesktopNav, renderMobileNav } from './layout/index.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import css_248z from './styles/pim-subnav.scss.js';
import { updateCategories } from './utils/index.js';

class PimSubnav extends s {
    constructor() {
        super(...arguments);
        this.categories = null;
        this.data = null;
        this.isHidden = true;
        this.query = '(max-width: 959px)';
        this.isMobile = false;
        this.debounceTimer = null;
    }
    handleMediaQuery(e) {
        this.isMobile = e.detail.value;
        this.requestUpdate();
    }
    connectedCallback() {
        super.connectedCallback();
        if (this.data)
            updateCategories(this.data, this);
    }
    firstUpdated() {
        this.collapseInactive();
    }
    toggleCategoryByName(name) {
        const elements = this.shadowRoot.querySelectorAll(`.subcategory-item[data-category="${name}"]`);
        if (elements.length > 0) {
            elements.forEach((el) => {
                const element = el;
                element.style.display = element.style.display === 'none' ? 'block' : 'none';
            });
        }
    }
    collapseInactive() {
        var _a;
        (_a = this.categories) === null || _a === void 0 ? void 0 : _a.forEach((cat) => {
            const result = cat.SubSubCategories.find(e => e.IsActive);
            if (!result)
                this.toggleCategoryByName(cat.Title);
        });
    }
    onCategoryClick() {
        // Don't update IsActive or call requestUpdate - DOM checkbox state is the source of truth
        // Debounce the navigation to allow multiple selections
        this.debounceApplyFilters();
    }
    debounceApplyFilters() {
        if (this.debounceTimer) {
            window.clearTimeout(this.debounceTimer);
        }
        this.debounceTimer = window.setTimeout(() => {
            this.applyAllFilters();
        }, 500);
    }
    applyAllFilters() {
        const currentUrl = new URL(window.location.href);
        const resultUrl = new URL(currentUrl.pathname, window.location.origin);
        // Copy non-filter params (keep search term, etc.)
        currentUrl.searchParams.forEach((value, key) => {
            if (key === 's') {
                resultUrl.searchParams.set(key, value);
            }
        });
        // Build filters from ALL checkboxes in the DOM (source of truth)
        const filtersByKey = new Map();
        // Query all checkboxes in the shadow DOM
        const checkboxes = this.shadowRoot.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            if (checkbox.checked && checkbox.value) {
                try {
                    const url = new URL(checkbox.value, window.location.origin);
                    url.searchParams.forEach((value, key) => {
                        if (!filtersByKey.has(key)) {
                            filtersByKey.set(key, new Set());
                        }
                        filtersByKey.get(key).add(value);
                    });
                }
                catch (e) {
                    // Invalid URL, skip
                }
            }
        });
        // Apply all filters as comma-separated values
        filtersByKey.forEach((values, key) => {
            resultUrl.searchParams.set(key, Array.from(values).join(','));
        });
        document.location.href = resultUrl.toString();
    }
    render() {
        return x `${!this.isMobile
            ? renderDesktopNav(this)
            : renderMobileNav(this)}<lit-media-query .query="${this.query}" @changed="${this.handleMediaQuery}"></lit-media-query>`;
    }
}
PimSubnav.styles = css_248z;
__decorate([
    n()
], PimSubnav.prototype, "data", void 0);
__decorate([
    n({ type: String })
], PimSubnav.prototype, "mobileMenuTitle", void 0);
__decorate([
    t()
], PimSubnav.prototype, "isHidden", void 0);
__decorate([
    t()
], PimSubnav.prototype, "query", void 0);
__decorate([
    t()
], PimSubnav.prototype, "isMobile", void 0);
__decorate([
    e('.subcategory-item')
], PimSubnav.prototype, "_subCategoryElements", void 0);
__decorate([
    e(':checked')
], PimSubnav.prototype, "checkedFilters", void 0);
customElements.define('pim-subnav', PimSubnav);

export { PimSubnav };
